import * as ActionType from '../actions/types'
import { BOOKABLE_TYPES, entryPointId } from 'settings/app/constants'

/**
 * parsing bookable elements and return clean, initial state
 * all bookable element can be compared
 * => compareKeys = a list from all others compare values (no qsr)
 * => qsrIdentifier = a list from all qsr Values
 * @returns {{}}
 */
const getInitialStateForCompareElements = () => {
  const initialResultState = {}

  BOOKABLE_TYPES.forEach((element) => {
    if (element === entryPointId.HOSPITALS) {
      initialResultState[element] = {
        detailsKeyArray: [],
        results: [],
        count: 0,
        isAop: null,
        isTreatmentReason: false, // <-- current not really used (its because compare without treatment, currently user can set this option, if user refresh the page then the data has original state)
        qsrIdentifier: [],
        compareKeys: [],
        generalTooltips: null,
      }
      return true
    }

    initialResultState[element] = {
      detailsKeyArray: [],
      count: 0,
      results: [],
      ...(element !== entryPointId.DOCTORS && { compareKeys: [] }),
      ...(element !== entryPointId.DOCTORS && { generalTooltips: null }),
    }
  })

  return initialResultState
}

/**
 * parsing bookable elements and return clean, initial state
 * all bookable element can be compared
 * => compareKeys = a list from all others compare values (no qsr)
 * => qsrIdentifier = a list from all qsr Values
 * @returns {{}}
 */
const getInitialStateForXHRElements = () => {
  const initialXHRState = {}

  BOOKABLE_TYPES.forEach((element) => {
    initialXHRState[element] = {
      initial: null,
      details: [],
    }
  })

  return initialXHRState
}

/**
 * INITIAL STATE OBJECT
 * result -> resultData (contains data from multiple xhr)
 *      xhr 1 => fetch the general data and compare data
 *      xhr 2 => fetch details data
 *
 * activeElements
 *      type => current compare type (doctors or hospitals)
 *      activeId => current compare item ids
 *
 * xhr (for reduce unnecessary xhr requests)
 *      initial => initial request (general information's and compare data)
 *      details => ids from compare items where the details loaded
 *
 * @type {{types: {}, xhr: {}, activeElements: {type: null, activeIds: *[]}, totalCount: number}}
 */
const INITIAL_STATE = {
  types: getInitialStateForCompareElements(),
  activeElements: {
    type: null,
    activeIds: [],
  },
  xhr: getInitialStateForXHRElements(), // stored proceeded xhrs (id)
  totalCount: 0,
}

const compareReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ActionType.REMOVE_ONE_RESULT_ITEM:
      return {
        ...state,
        [action.payload.resultTyp]: {
          ...state[action.payload.resultTyp],
          results: action.payload.results,
        },
        types: {
          ...state.types,
          [action.payload.resultTyp]: {
            ...state.types[action.payload.resultTyp],
            results: action.payload.results,
          },
        },
      }

    case ActionType.SET_ACTIVE_COMPARE_ELEMENTS:
      return {
        ...state,
        activeElements: {
          type: action.payload.resultTyp,
          activeIds: action.payload.activeElements,
        },
      }

    case ActionType.FETCH_COMPARE_DETAILS_COMPLETE:
      return {
        ...state,
        types: {
          ...state.types,
          [action.payload.resultTyp]: {
            ...state.types[action.payload.resultTyp],
            results: [...action.payload.results],
            detailsKeyArray: [...action.payload.detailsKeyArray],
          },
        },
        xhr: {
          ...state.xhr,
          [action.payload.resultTyp]: {
            ...state.xhr[action.payload.resultTyp],
            details: [...action.payload.details],
          },
        },
      }

    case ActionType.FETCH_COMPARE_ITEMS_COMPLETE:
      switch (action.payload.resultTyp) {
        // has compare able data and tooltips
        case entryPointId.HOSPITALS:
          return {
            ...state,
            activeElements: {
              type: action.payload.resultTyp,
              activeIds: action.payload.activeElements,
            },
            types: {
              ...state.types,
              [action.payload.resultTyp]: {
                ...state.types[action.payload.resultTyp],
                results: action.payload.data.results,
                count: action.payload.data.count,
                isAop: action.payload.data.is_aop,
                isTreatmentReason: action.payload.data.is_treatment_reason,
                qsrIdentifier: action.payload.data.qsrIdentifier,
                generalTooltips: action.payload.data.generalTooltips,
                compareKeys: action.payload.data.compareKeys,
              },
            },
            xhr: {
              ...state.xhr,
              [action.payload.resultTyp]: {
                ...state.xhr[action.payload.resultTyp],
                initial: true,
              },
            },
          }

        // has compare able data and tooltips
        case entryPointId.CAREHOMES:
        case entryPointId.DAYANDNIGHTCARE:
        case entryPointId.CARESERVICES:
        case entryPointId.CARESUPPORT:
          return {
            ...state,
            activeElements: {
              type: action.payload.resultTyp,
              activeIds: action.payload.activeElements,
            },
            types: {
              ...state.types,
              [action.payload.resultTyp]: {
                ...state.types[action.payload.resultTyp],
                results: action.payload.data.results,
                count: action.payload.data.count,
                generalTooltips: action.payload.data.generalTooltips,
                compareKeys: action.payload.data.compareKeys,
              },
            },
            xhr: {
              ...state.xhr,
              [action.payload.resultTyp]: {
                ...state.xhr[action.payload.resultTyp],
                initial: true,
              },
            },
          }

        // doctors (no compare data)
        default:
          return {
            ...state,
            activeElements: {
              type: action.payload.resultTyp,
              activeIds: action.payload.activeElements,
            },
            types: {
              ...state.types,
              [action.payload.resultTyp]: {
                ...state.types[action.payload.resultTyp],
                results: action.payload.data.results,
                count: action.payload.data.count,
                compareKeys: action.payload.data.compareKeys,
              },
            },
            xhr: {
              ...state.xhr,
              [action.payload.resultTyp]: {
                ...state.xhr[action.payload.resultTyp],
                initial: true,
              },
            },
          }
      }

    case ActionType.TOGGLE_ACTIVE_COMPARE_ITEMS:
      if (action.payload.resultTyp === entryPointId.HOSPITALS) {
        return {
          ...state,
          activeElements: {
            ...action.payload.activeElements,
          },
          qsrIdentifier: action.payload.qsrIdentifier,
        }
      }
      return {
        ...state,
        activeElements: {
          ...action.payload.activeElements,
        },
      }

    case ActionType.RESET_COMPARE_STATE:
      return {
        ...INITIAL_STATE,
      }

    default:
      return state
  }
}

export default compareReducer
